import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fa39bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-not-available" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-container" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-circle warning-icon",
    style: {"color":"#00AAB4"}
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "Due to the complex variety of data and graphs, this screen is designed to be viewed fullscreen on Desktop.")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}